<template>
	<div class="sideways-content-fold" v-if="activePanel">
		<div class="portlet light bordered" v-if="process !== 'next_actions'">
			<div class="portlet-title">
				<div class="caption">
					Edit Contest Layout
				</div>
			</div>
			<div class="portlet-body">
				<form role="form" @submit.prevent="updateContestLayout($event)" novalidate>
					<transition name="fade" mode="out-in">
						<div v-if="process === 'step_1'" key="step_1">
							<div class="col-sm-7 scroll-column">
								<div class="alert alert-danger" v-if="errorMessage.length">
								    <button class="close" data-close="alert" @click="clearError()"></button>
			                        <span>{{ errorMessage }}</span>
								</div>
								<div class="form-body invite-user-form">
									<div class="form-md-checkboxes margin-bottom-20">
	                    				<div class="md-checkbox-inline">
	                    					<div class="md-checkbox">
	                    						<input type="checkbox" id="checkbox-skip-form-step" class="md-check" v-model="contestLayout.form.skip_form" :disabled="process !== 'step_1'">
	                    						<label for="checkbox-skip-form-step">
	                    							<span></span>
	                    							<span class="check"></span>
	                    							<span class="box"></span>
	                    							Skip Form Step
	                    						</label>
	                    						<info-popover :content="'Enabling this will bypass the form and take the user directly to the digital scratch card.'"></info-popover>
	                    					</div>
	                    				</div>
	                    			</div>
								</div>
								<div class="margin-bottom-20" v-if="!contestLayout.form.skip_form">
									<label class="dropdown-label-override">Language</label>
									<dropdown :forceUpdate="transitionComplete">
										<button slot="button" type="button" class="btn btn-sm btn-outline dropdown-toggle btn-default" data-toggle="dropdown">
											{{ contestLayout.form.language }}
											<i class="fa fa-angle-down"></i>
										</button>
										<ul slot="dropdown-menu" class="dropdown-menu">
											<li>
												<a @click="setFormLanguage('english')">English</a>
											</li>
											<li>
												<a @click="setFormLanguage('french')">French</a>
											</li>
										</ul>
									</dropdown>
								</div>
								<div class="form-group form-md-line-input form-md-floating-label margin-bottom-40" v-if="!contestLayout.form.skip_form">
		                            <input type="text" class="form-control input-sm" :class="{'edited': contestLayout.form.form_instructions.length}" id="edit_design_layout_form_instructions" v-model.trim="contestLayout.form.form_instructions" maxlength="255">
		                            <label for="edit_design_layout_form_instructions">Form Instructions</label>
		                            <span class="help-block persist">The instructions that will be presented to the user.</span>
		                        </div>
		                        <div class="form-group form-md-line-input form-md-floating-label margin-bottom-40" v-if="campaignType === 'ig' && !contestLayout.form.skip_form">
		                            <input type="text" class="form-control input-sm" :class="{'edited': contestLayout.form.thank_you_text.length}" id="edit_design_layout_thank_you" v-model.trim="contestLayout.form.thank_you_text" maxlength="255">
		                            <label for="edit_design_layout_thank_you">Thank You Message</label>
		                            <span class="help-block persist">The message that will be presented to the user.</span>
		                        </div>
		                        <div class="form-group form-md-line-input form-md-floating-label" v-if="!contestLayout.form.skip_form">
									<input type="number" class="form-control input-sm" id="edit_design_layout_form_min_age" v-model.number="contestLayout.form.min_age" :class="{'edited': contestLayout.form.min_age || contestLayout.form.min_age === 0}" :disabled="contestLayout.form.no_age">
								    <label for="edit_design_layout_form_min_age">Age Limit</label>
								    <span class="help-block persist">Set the minimum age required for the user to enter the contest.</span>
								</div>
								<div class="form-md-checkboxes margin-bottom-20" v-if="!contestLayout.form.skip_form">
	                				<div class="md-checkbox-inline">
	                					<div class="md-checkbox">
	                						<input type="checkbox" id="checkbox-no-age-limit" class="md-check" v-model="contestLayout.form.no_age" :disabled="process !== 'step_1'">
	                						<label for="checkbox-no-age-limit">
	                							<span></span>
	                							<span class="check"></span>
	                							<span class="box"></span>
	                							No age limit
	                						</label>
	                					</div>
	                				</div>
	                			</div>
	                			<div class="portlet box blue-hoki" v-if="!contestLayout.form.skip_form">
	                				<div class="portlet-title">
	                					<div class="caption">
	                						<i class="fa fa-list"></i>
	                						Form Information
	                					</div>
	                				</div>
	                				<div class="portlet-body">
	                					<span class="help-block">Choose the fields to show on the form and which fields are required.</span>
	                					<div class="margin-top-20 row search-content-4">
				      						<div class="search-table table-responsive">
				      							<table class="table table-striped table-condensed">
				      								<thead>
				      									<tr>
				      										<th></th>
				      										<th><a class="no-click font-grey-mint">Request Field</a></th>
				      										<th><a class="no-click font-grey-mint">Require Field</a></th>
				      									</tr>
				      								</thead>
				      								<tbody>
				      									<tr>
				      										<td><h4>Full Name</h4></td>
					      									<td>
					      										<div class="md-checkbox">
						      										<input type="checkbox" id="form_fields_full_name_request" class="md-check" v-model="contestLayout.form.fields.full_name.request" @change="forceFieldSelection('request', 'full_name')">
						      										<label for="form_fields_full_name_request">
						      											<span></span>
						      											<span class="check"></span>
						      											<span class="box"></span>
						      										</label>
						      									</div>
					      									</td>
					      									<td>
					      										<div class="md-checkbox">
						      										<input type="checkbox" id="form_fields_full_name_require" class="md-check" v-model="contestLayout.form.fields.full_name.require" @change="forceFieldSelection('require', 'full_name')">
						      										<label for="form_fields_full_name_require">
						      											<span></span>
						      											<span class="check"></span>
						      											<span class="box"></span>
						      										</label>
						      									</div>
					      									</td>
					      								</tr>
					      								<tr>
				      										<td><h4>Email</h4></td>
					      									<td>
					      										<div class="md-checkbox">
						      										<input type="checkbox" id="form_fields_email_request" class="md-check" v-model="contestLayout.form.fields.email.request" @change="forceFieldSelection('request', 'email')">
						      										<label for="form_fields_email_request">
						      											<span></span>
						      											<span class="check"></span>
						      											<span class="box"></span>
						      										</label>
						      									</div>
					      									</td>
					      									<td>
					      										<div class="md-checkbox">
						      										<input type="checkbox" id="form_fields_email_require" class="md-check" v-model="contestLayout.form.fields.email.require" @change="forceFieldSelection('require', 'email')">
						      										<label for="form_fields_email_require">
						      											<span></span>
						      											<span class="check"></span>
						      											<span class="box"></span>
						      										</label>
						      									</div>
					      									</td>
					      								</tr>
					      								<tr>
				      										<td><h4>Phone #</h4></td>
					      									<td>
					      										<div class="md-checkbox">
						      										<input type="checkbox" id="form_fields_phone_request" class="md-check" v-model="contestLayout.form.fields.phone.request" @change="forceFieldSelection('request', 'phone')">
						      										<label for="form_fields_phone_request">
						      											<span></span>
						      											<span class="check"></span>
						      											<span class="box"></span>
						      										</label>
						      									</div>
					      									</td>
					      									<td>
					      										<div class="md-checkbox">
						      										<input type="checkbox" id="form_fields_phone_require" class="md-check" v-model="contestLayout.form.fields.phone.require" @change="forceFieldSelection('require', 'phone')">
						      										<label for="form_fields_phone_require">
						      											<span></span>
						      											<span class="check"></span>
						      											<span class="box"></span>
						      										</label>
						      									</div>
					      									</td>
					      								</tr>
					      								<tr>
				      										<td><h4>Date of Birth</h4></td>
					      									<td>
					      										<div class="md-checkbox">
						      										<input type="checkbox" id="form_fields_dob_request" class="md-check" v-model="contestLayout.form.fields.dob.request" @change="forceFieldSelection('request', 'dob')">
						      										<label for="form_fields_dob_request">
						      											<span></span>
						      											<span class="check"></span>
						      											<span class="box"></span>
						      										</label>
						      									</div>
					      									</td>
					      									<td>
					      										<div class="md-checkbox">
						      										<input type="checkbox" id="form_fields_dob_require" class="md-check" v-model="contestLayout.form.fields.dob.require" @change="forceFieldSelection('require', 'dob')">
						      										<label for="form_fields_dob_require">
						      											<span></span>
						      											<span class="check"></span>
						      											<span class="box"></span>
						      										</label>
						      									</div>
					      									</td>
					      								</tr>
				      								</tbody>
				      							</table>
				      						</div>
				      					</div>
	                				</div>
	                			</div>
	                			<div class="form-md-checkboxes" v-if="!contestLayout.form.skip_form">
                    				<div class="md-checkbox-inline">
                    					<div class="md-checkbox">
                    						<input type="checkbox" id="checkbox-email-response" class="md-check" v-model="contestLayout.form.thank_you_email" :disabled="process !== 'step_1'">
                    						<label for="checkbox-email-response">
                    							<span></span>
                    							<span class="check"></span>
                    							<span class="box"></span>
                    							Enable response email
                    						</label>
                    						<info-popover :content="'This will send the user an email response after entering the contest.'"></info-popover>
                    					</div>
                    				</div>
                    			</div>
                    			<div class="form-group form-md-line-input form-md-floating-label margin-bottom-40" v-if="!contestLayout.form.skip_form && contestLayout.form.thank_you_email">
		                            <input type="text" class="form-control input-sm" :class="{'edited': contestLayout.form.email_fields.sender.length}" id="edit_design_layout_email_sender" v-model.trim="contestLayout.form.email_fields.sender" maxlength="255">
		                            <label for="edit_design_layout_email_sender">Sender Name</label>
		                            <span class="help-block persist">The email will send from do-not-reply@unoapp.com.</span>
		                        </div>
		                        <div class="form-group form-md-line-input form-md-floating-label margin-bottom-40" v-if="!contestLayout.form.skip_form && contestLayout.form.thank_you_email">
		                            <input type="text" class="form-control input-sm" :class="{'edited': contestLayout.form.email_fields.subject.length}" id="edit_design_layout_email_subject" v-model.trim="contestLayout.form.email_fields.subject" maxlength="255">
		                            <label for="edit_design_layout_email_subject">Subject</label>
		                        </div>
		                        <div class="form-group form-md-line-input form-md-floating-label margin-bottom-40" v-if="!contestLayout.form.skip_form && contestLayout.form.thank_you_email">
		                            <textarea type="text" class="form-control input-sm" :class="{'edited': contestLayout.form.email_fields.body.length}" id="edit_design_layout_email_body" v-model.trim="contestLayout.form.email_fields.body" maxlength="255"></textarea>
		                            <label for="edit_design_layout_email_body">Body</label>
		                        </div>
		                        <div class="form-actions noborder invite-user-actions margin-top-20 margin-bottom-100">
		                        	<button type="button" class="btn btn-default" @click="closePanel()"> Return To UNOgames Dashboard</button>
		                        	<button type="button" class="btn blue" @click="advanceForm($event, 'step_2', 'step_1')" key="edit-contest-design-continue-one">Continue <i class="fa fa-arrow-circle-right"></i></button>
		                        </div>
	                		</div>
	                		<div class="col-sm-5">
	                			<contest-preview :design="contestLayout.design" :form="contestLayout.form" :agreement="contestLayout.agreement"></contest-preview>
	                		</div>
						</div>
						<div v-if="process === 'step_2'" key="step_2">
							<div class="col-sm-7 scroll-column">
								<div class="alert alert-danger" v-if="errorMessage.length">
								    <button class="close" data-close="alert" @click="clearError()"></button>
			                        <span>{{ errorMessage }}</span>
								</div>
								<div class="row">
									<div class="col-sm-6">
										<div class="form-group form-md-line-input form-md-floating-label">
			                                <div class="input-icon right">
			                                    <input type="text" class="form-control input-sm" id="design_text_color" v-model="contestLayout.design.text_color" :class="{'edited': contestLayout.design.text_color.length}">
			                                    <label for="design_text_color">Text Color</label>
			                                    <i class="wide clickable"><el-color-picker v-model="contestLayout.design.text_color" show-alpha></el-color-picker></i>
			                                </div>
			                            </div>
			                            <div class="form-group form-md-line-input form-md-floating-label">
			                                <div class="input-icon right">
			                                    <input type="text" class="form-control input-sm" id="design_input_text_color" v-model="contestLayout.design.input_text_color" :class="{'edited': contestLayout.design.input_text_color.length}">
			                                    <label for="design_input_text_color">Input Text Color</label>
			                                    <i class="wide clickable"><el-color-picker v-model="contestLayout.design.input_text_color" show-alpha></el-color-picker></i>
			                                </div>
			                            </div>
			                            <div class="form-group form-md-line-input form-md-floating-label">
			                                <div class="input-icon right">
			                                    <input type="text" class="form-control input-sm" id="design_background_color" v-model="contestLayout.design.background_color" :class="{'edited': contestLayout.design.background_color.length}">
			                                    <label for="design_background_color">Background Color</label>
			                                    <i class="wide clickable"><el-color-picker v-model="contestLayout.design.background_color" show-alpha></el-color-picker></i>
			                                </div>
			                            </div>
			                            <div class="form-group form-md-line-input form-md-floating-label margin-bottom-20">
				                            <input type="text" class="form-control input-sm" :class="{'edited': contestLayout.design.background_image.length}" id="design_background_image" v-model.trim="contestLayout.design.background_image">
				                            <label for="design_background_image">Background Image</label>
				                        </div>
				                        <div class="form-group form-md-line-input form-md-floating-label margin-bottom-20">
				                            <input type="text" class="form-control input-sm" :class="{'edited': contestLayout.design.header_image.length}" id="design_header_image" v-model.trim="contestLayout.design.header_image">
				                            <label for="design_header_image">Header Image</label>
				                        </div>
				                        <div class="form-group form-md-line-input form-md-floating-label margin-bottom-20">
				                            <input type="text" class="form-control input-sm" :class="{'edited': contestLayout.design.footer_image.length}" id="design_footer_image" v-model.trim="contestLayout.design.footer_image">
				                            <label for="design_footer_image">Footer Image</label>
				                        </div>
			                            <div class="form-group form-md-line-input form-md-floating-label">
			                                <div class="input-icon right">
			                                    <input type="text" class="form-control input-sm" id="design_footer_background_color" v-model="contestLayout.design.footer_background_color" :class="{'edited': contestLayout.design.footer_background_color.length}">
			                                    <label for="design_footer_background_color">Footer Background Color</label>
			                                    <i class="wide clickable"><el-color-picker v-model="contestLayout.design.footer_background_color" show-alpha></el-color-picker></i>
			                                </div>
			                            </div>
			                            <div class="form-group form-md-line-input form-md-floating-label">
			                                <div class="input-icon right">
			                                    <input type="text" class="form-control input-sm" id="design_footer_border_color" v-model="contestLayout.design.footer_border_color" :class="{'edited': contestLayout.design.footer_border_color.length}">
			                                    <label for="design_footer_border_color">Footer Border Color</label>
			                                    <i class="wide clickable"><el-color-picker v-model="contestLayout.design.footer_border_color" show-alpha></el-color-picker></i>
			                                </div>
			                            </div>
			                        </div>
			                        <div class="col-sm-6">
			                        	<div class="form-group form-md-line-input form-md-floating-label">
			                                <div class="input-icon right">
			                                    <input type="text" class="form-control input-sm" id="design_input_background_color" v-model="contestLayout.design.input_background_color" :class="{'edited': contestLayout.design.input_background_color.length}">
			                                    <label for="design_input_background_color">Input Background Color</label>
			                                    <i class="wide clickable"><el-color-picker v-model="contestLayout.design.input_background_color" show-alpha></el-color-picker></i>
			                                </div>
			                            </div>
			                            <div class="form-group form-md-line-input form-md-floating-label">
			                                <div class="input-icon right">
			                                    <input type="text" class="form-control input-sm" id="design_input_placeholder_color" v-model="contestLayout.design.input_placeholder_color" :class="{'edited': contestLayout.design.input_placeholder_color.length}">
			                                    <label for="design_input_placeholder_color">Input Placeholder Color</label>
			                                    <i class="wide clickable"><el-color-picker v-model="contestLayout.design.input_placeholder_color" show-alpha></el-color-picker></i>
			                                </div>
			                            </div>
			                            <div class="form-group form-md-line-input form-md-floating-label">
			                                <div class="input-icon right">
			                                    <input type="text" class="form-control input-sm" id="design_button_text_color" v-model="contestLayout.design.button_text_color" :class="{'edited': contestLayout.design.button_text_color.length}">
			                                    <label for="design_button_text_color">Button Text Color</label>
			                                    <i class="wide clickable"><el-color-picker v-model="contestLayout.design.button_text_color" show-alpha></el-color-picker></i>
			                                </div>
			                            </div>
			                            <div class="form-group form-md-line-input form-md-floating-label">
			                                <div class="input-icon right">
			                                    <input type="text" class="form-control input-sm" id="design_button_background_color" v-model="contestLayout.design.button_background_color" :class="{'edited': contestLayout.design.button_background_color.length}">
			                                    <label for="design_button_background_color">Button Background Color</label>
			                                    <i class="wide clickable"><el-color-picker v-model="contestLayout.design.button_background_color" show-alpha></el-color-picker></i>
			                                </div>
			                            </div>
			                            <div class="form-group form-md-line-input form-md-floating-label">
			                                <div class="input-icon right">
			                                    <input type="text" class="form-control input-sm" id="design_button_background_hover_color" v-model="contestLayout.design.button_background_hover_color" :class="{'edited': contestLayout.design.button_background_hover_color.length}">
			                                    <label for="design_button_background_hover_color">Button Hover Color</label>
			                                    <i class="wide clickable"><el-color-picker v-model="contestLayout.design.button_background_hover_color" show-alpha></el-color-picker></i>
			                                </div>
			                            </div>
			                            <div class="margin-bottom-20">
											<label class="dropdown-label-override">Font Family</label>
											<font-picker @updateFont="setFontFamily" :passedFont="contestLayout.design.font_family"></font-picker>
										</div>
										<div class="margin-bottom-20" v-if="contestLayout.design.font_family.family">
											<label class="dropdown-label-override">Font Weight</label>
											<dropdown class="full-width">
												<button slot="button" type="button" class="btn btn-sm btn-outline dropdown-toggle btn-default full-width" data-toggle="dropdown">
													{{ contestLayout.design.font_weight || 'Select a Font Weight'}}
													<i class="fa fa-angle-down pull-right"></i>
												</button>
												<ul slot="dropdown-menu" class="dropdown-menu full-width">
													<template v-for="weight in fontWeights">
														<li v-if="contestLayout.design.font_family.variants.indexOf(weight.name) !== -1">
															<a @click="setFontWeight(weight)" :style="{fontWeight: weight.weight}">{{ weight.weight }}</a>
														</li>
													</template>
												</ul>
											</dropdown>
										</div>
			                        </div>
			                    </div>
								<div class="form-actions noborder invite-user-actions margin-top-20 margin-bottom-100">
									<button type="button" class="btn btn-default" @click="closePanel()"> Return To UNOgames Dashboard</button>
									<button type="button" class="btn btn-default" @click="reverseForm()">Back</button>
									<button type="button" class="btn blue" @click="advanceForm($event, 'step_3', 'step_2')" key="edit-contest-design-continue-two">Continue <i class="fa fa-arrow-circle-right"></i></button>
								</div>
							</div>
							<div class="col-sm-5">
								<contest-preview :design="contestLayout.design" :form="contestLayout.form"  :agreement="contestLayout.agreement"></contest-preview>
	                		</div>
						</div>
						<div v-if="process === 'step_3'" key="step_3">
							<div class="col-sm-7 scroll-column">
								<div class="alert alert-danger" v-if="errorMessage.length">
								    <button class="close" data-close="alert" @click="clearError()"></button>
			                        <span>{{ errorMessage }}</span>
								</div>
								<div class="form-group form-md-line-input form-md-floating-label margin-bottom-20">
		                            <input type="text" class="form-control input-sm" :class="{'edited': contestLayout.agreement.urls[0].url.length}" id="edit_agreement_url_1" v-model.trim="contestLayout.agreement.urls[0].url" maxlength="255">
		                            <label for="edit_agreement_url_1">Agreement URL</label>
		                        </div>
		                        <div class="form-group form-md-line-input form-md-floating-label margin-bottom-20">
		                            <input type="text" class="form-control input-sm" :class="{'edited': contestLayout.agreement.urls[0].name.length}" id="edit_agreement_name_1" v-model.trim="contestLayout.agreement.urls[0].name" maxlength="255">
		                            <label for="edit_agreement_name_1">Agreement Name</label>
		                        </div>
		                        <div class="form-group form-md-line-input form-md-floating-label margin-bottom-20">
		                            <input type="text" class="form-control input-sm" :class="{'edited': contestLayout.agreement.urls[1].url.length}" id="edit_agreement_url_2" v-model.trim="contestLayout.agreement.urls[1].url" maxlength="255">
		                            <label for="edit_agreement_url_2">Agreement URL</label>
		                        </div>
		                        <div class="form-group form-md-line-input form-md-floating-label margin-bottom-20">
		                            <input type="text" class="form-control input-sm" :class="{'edited': contestLayout.agreement.urls[1].name.length}" id="edit_agreement_name_2" v-model.trim="contestLayout.agreement.urls[1].name" maxlength="255">
		                            <label for="edit_agreement_name_2">Agreement Name</label>
		                        </div>
		                        <div class="form-group form-md-line-input form-md-floating-label margin-bottom-20">
		                            <input type="text" class="form-control input-sm" :class="{'edited': contestLayout.agreement.terms_error.length}" id="edit_agreement_terms_error" v-model.trim="contestLayout.agreement.terms_error" maxlength="255">
		                            <label for="edit_agreement_terms_error">Terms and Conditions Error</label>
		                            <span class="help-block persist">The message that will be displayed to the user if they fail to accept the terms and conditions.</span>
		                        </div>
		                        <div class="form-md-checkboxes margin-top-40">
                    				<div class="md-checkbox-inline">
                    					<div class="md-checkbox">
                    						<input type="checkbox" id="checkbox-require-access-code" class="md-check" v-model="contestLayout.agreement.require_access_code">
                    						<label for="checkbox-require-access-code">
                    							<span></span>
                    							<span class="check"></span>
                    							<span class="box"></span>
                    							Require Access Code
                    						</label>
                    						<info-popover :content="'Access Code is used to verify that a prize has been redeemed.'"></info-popover>
                    					</div>
                    				</div>
                    			</div>
                    			<div class="form-group form-md-line-input form-md-floating-label margin-bottom-40" v-if="contestLayout.agreement.require_access_code">
		                            <input type="text" class="form-control input-sm" :class="{'edited': contestLayout.agreement.access_code.length}" id="edit_agreement_access_code" v-model.trim="contestLayout.agreement.access_code" maxlength="255">
		                            <label for="edit_agreement_access_code">Access Code</label>
		                            <span class="help-block persist">The access code that is required to claim the prize.</span>
		                        </div>
		                        <div class="form-actions noborder invite-user-actions margin-top-20 margin-bottom-100">
									<button type="button" class="btn btn-default" @click="closePanel()"> Return To UNOgames Dashboard</button>
									<button type="button" class="btn btn-default" @click="reverseForm()">Back</button>
									<button type="submit" class="btn blue">Submit</button>
								</div>
							</div>
							<div class="col-sm-5">
								<contest-preview :design="contestLayout.design" :form="contestLayout.form" :agreement="contestLayout.agreement"></contest-preview>
	                		</div>
						</div>
					</transition>
					<step-counter :steps="steps" :process="process"></step-counter>
				</form>
			</div>
		</div>
		<next-actions v-else :actionsList="editContestLayoutNextActions" @runFunction="runFunction"></next-actions>
	</div>
</template>
<script>
import GlobalFunctions from '../../../global'
import Dropdown from '../../modules/Dropdown'
import FontPicker from '../../modules/FontPicker'
import InfoPopover from '../../modules/InfoPopover'
import NextActions from '../../modules/NextActions'
import StepCounter from '../../modules/StepCounter'
import ContestPreview from './ContestPreview'
import { findIndex } from 'lodash'
import WebFont from 'webfontloader'
import UNOgames from '../../../controllers/UNOgames'
import { mapGetters } from 'vuex'

/**
 * Edit Contest Layout module is a page for editing the design of the contest page.
 * @class EditContestLayout
 * @extends UNOgames
 * @since 0.0.9
 */

export default {
	name: 'edit-contest-layout',
	data () {
		return {
			process: 'step_1',
			activePanel: false,
			errorMessage: '',
			campaignId: 0,
			contestId: 0,
			campaignType: '',
			contestLayout: {
				form: {
					skip_form: false,
					language: 'english',
					form_instructions: '',
					thank_you_text: '',
					no_age: false,
					fields: {
						full_name: {
							request: true,
							require: false
						},
						email: {
							request: true,
							require: false
						},
						phone: {
							request: true,
							require: false
						},
						dob: {
							request: true,
							require: false
						}
					},
					thank_you_email: false,
					email_fields: {
						sender: '',
						subject: '',
						body: ''
					}
				},
				design: {
					text_color: '',
					input_text_color: '',
					background_color: '',
					background_image: '',
					header_image: '',
					footer_image: '',
					footer_background_color: '',
					footer_border_color: '',
					input_background_color: '',
					input_placeholder_color: '',
					button_text_color: '',
					button_background_color: '',
					button_background_hover_color: '',
					font_family: {},
					font_weight: 400
				},
				agreement: {
					urls: [
						{
							url: '',
							name: ''
						},
						{
							url: '',
							name: ''
						}
					],
					terms_error: '',
					require_access_code: false,
					access_code: ''
				}
			},
			steps: [{key: 'step_1', name: 'Form Details'}, {key: 'step_2', name: 'Page Design'}, {key: 'step_3', name: 'Agreement Details'}],
			fontWeights: [
				{weight: 100, name: '100'},
				{weight: 200, name: '200'},
				{weight: 300, name: '300'},
				{weight: 400, name: 'regular'},
				{weight: 500, name: '500'},
				{weight: 600, name: '600'},
				{weight: 700, name: '700'},
				{weight: 800, name: '800'},
				{weight: 900, name: '900'}
			],
			editContestLayoutNextActions: [{title: 'Return to Campaign Dashboard', icon_class: 'fa fa-arrow-circle-left', click_event: 'closePanel'}],
			transitionComplete: false
		}
	},
	/**
	 * Run on created to determine if this should be the active panel or not.
	 * @function
	 * @return {undefined}
	 * @memberof EditContestLayout
	 * @version 0.0.9
	 */
	created () {
		if (this.$route.name === 'UNOgames - Edit Contest Layout') {
			this.activePanel = true
			if (this.$route.params.campaign_id && this.$route.params.campaign_id !== 'undefined' && parseInt(this.$route.params.campaign_id) !== 0) {
				this.campaignId = this.$route.params.campaign_id

				this.transitionComplete = false
				setTimeout(() => {
					this.transitionComplete = true
				}, 600)

				this.getContestDetails()
			} else {
				this.closePanel()
			}
		} else {
			this.activePanel = false
		}
	},
	computed: mapGetters([
		'activeLocationId'
	]),
	methods: {
		/**
		 * To clear the current error.
		 * @function
		 * @returns {undefined}
		 * @memberof EditContestLayout
		 * @version 0.0.9
		 */
		clearError () {
			this.errorMessage = ''
		},
		/**
		 * To close the edit contest layout panel by redirecting to the dashboard
		 * @function
		 * @returns {undefined}
		 * @memberof EditContestLayout
		 * @version 0.0.9
		 */
		closePanel () {
			this.process = 'step_1'
			this.$router.push('/app/uno_games')
		},
		/**
		 * To move the form back to the previous step
		 * @function
		 * @returns {undefined}
		 * @memberof EditContestLayout
		 * @version 0.0.9
		 */
		reverseForm () {
			const index = findIndex(this.steps, ['key', this.process])
			if (index) {
				this.process = this.steps[index - 1].key
			}

			return
		},
		/**
		 * To set the form language.
		 * @function
		 * @param {string} language - The language to be set.
		 * @returns {undefined}
		 * @memberof EditContestLayout
		 * @version 0.0.9
		 */
		setFormLanguage (language) {
			this.contestLayout.form.language = language
		},
		/**
		 * To force checkboxes to be selected or deselected based off of chosen option.
		 * @function
		 * @param {string} type - The type of checkbox that was clicked.
		 * @param {string} field - The field that is being altered.
		 * @returns {undefined}
		 * @memberof EditContestLayout
		 * @version 0.0.9
		 */
		forceFieldSelection (type, field) {
			switch (type) {
			case 'require':
				if (this.contestLayout.form.fields[field].require === true) {
					this.contestLayout.form.fields[field].request = true
				}
				break

			case 'request':
				if (this.contestLayout.form.fields[field].request === false) {
					this.contestLayout.form.fields[field].require = false
				}
				break

			default:
				// No Default
			}

			return
		},
		/**
		 * To validate that all information on the current step is accurate before allowing the user to proceed.
		 * @function
		 * @param {string} step - The step to be tested.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof EditContestLayout
		 * @version 0.0.9
		 */
		validateFormData (step) {
			let _this = this

			return new Promise((resolve, reject) => {
				switch (step) {
				case 'step_1':
					if (_this.contestLayout.form.skip_form) {
						resolve()
					}
					if (!_this.contestLayout.form.language) {
						reject('Language cannot be blank.')
					}
					if (!_this.contestLayout.form.form_instructions) {
						reject('Form instructions cannot be blank.')
					}
					if (_this.campaignType === 'ig' && !_this.contestLayout.form.thank_you_text) {
						reject('Thank you message cannot be blank.')
					}
					if (!_this.contestLayout.form.min_age && !_this.contestLayout.form.no_age) {
						reject('Age limit cannot be blank.')
					}
					if (_this.contestLayout.form.thank_you_email) {
						if (!_this.contestLayout.form.email_fields.sender) {
							reject('Email sender name cannot be blank.')
						}
						if (!_this.contestLayout.form.email_fields.subject) {
							reject('Email subject cannot be blank.')
						}
						if (!_this.contestLayout.form.email_fields.body) {
							reject('Email body cannot be blank.')
						}
					}
					break

				case 'step_2':
					if (!_this.contestLayout.design.text_color.length) {
						reject('Text Color cannot be blank.')
					}
					if (!_this.contestLayout.form.skip_form) {
						if (!_this.contestLayout.design.input_text_color.length) {
							reject('Input Text Color cannot be blank.')
						}
					}
					if (!_this.contestLayout.design.background_color.length && !_this.contestLayout.design.background_image.length) {
						reject('Your design must have either a background color or background image.')
					}
					if (!_this.contestLayout.design.header_image.length) {
						reject('Header Image cannot be blank.')
					}
					if (!_this.contestLayout.form.skip_form) {
						if (!_this.contestLayout.design.input_background_color.length) {
							reject('Input Background Color cannot be blank.')
						}
						if (!_this.contestLayout.design.input_placeholder_color.length) {
							reject('Input Placeholder Color cannot be blank.')
						}
					}
					if (!_this.contestLayout.design.button_text_color.length) {
						reject('Button Text Color cannot be blank.')
					}
					if (!_this.contestLayout.design.button_background_color.length) {
						reject('Button Background Color cannot be blank.')
					}
					if (!_this.contestLayout.design.button_background_hover_color.length) {
						reject('Button Hover Color cannot be blank.')
					}
					break

				case 'step_3':
					if (_this.contestLayout.agreement.require_access_code) {
						if (!_this.contestLayout.agreement.access_code.length) {
							reject('Access Code cannot be blank if you require an access code.')
						}
					}
					break

				default:
					resolve()
				}

				resolve()
			})
		},
		/**
		 * To move to the next step of the form.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @param {string} step - The step that we are moving to.
		 * @param {string} currentStep - The current step.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof EditContestLayout
		 * @version 0.0.9
		 */
		advanceForm (event, step, currentStep) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			return this.validateFormData(currentStep).then(response => {
				_this.clearError()
				disabledButton.complete().then(() => {
					_this.process = step
				})
			}).catch(reason => {
				// If validation fails then display the error message
				_this.errorMessage = reason
				disabledButton.cancel()
			})
		},
		/**
		 * To set the font family for the design and reset the font weight if it is not an acceptable option.
		 * @function
		 * @param {object} font - The font that is being selected.
		 * @returns {undefined}
		 * @memberof EditContestLayout
		 * @version 0.0.9
		 */
		setFontFamily (font) {
			this.contestLayout.design.font_family = font

			if (this.contestLayout.design.font_weight) {
				if (this.contestLayout.design.font_family.variants.indexOf(this.contestLayout.design.font_weight.toString()) === -1) {
					this.contestLayout.design.font_weight = 400
				}
			}

			WebFont.load({
				google: {
					families: [`${font.family}:${this.contestLayout.design.font_weight}`]
				}
			})
		},
		/**
		 * To set the font weight for the design.
		 * @function
		 * @param {object} weight - The weight that is being selected.
		 * @returns {undefined}
		 * @memberof EditContestLayout
		 * @version 0.0.9
		 */
		setFontWeight (weight) {
			this.contestLayout.design.font_weight = weight.weight

			WebFont.load({
				google: {
					families: [`${this.contestLayout.design.font_family.family}:${weight.weight}`]
				}
			})
		},
		/**
		 * To send the updated contest details of the campaign to the backend.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @returns {undefined}
		 * @memberof EditContestLayout
		 * @version 0.0.9
		 */
		updateContestLayout (event) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			return _this.validateFormData('step_3').then(response => {
				_this.clearError()
				if (_this.contestLayout.form.skip_form) {
					delete _this.contestLayout.form.language
					delete _this.contestLayout.form.form_instructions
					delete _this.contestLayout.form.thank_you_text
					delete _this.contestLayout.form.no_age
					delete _this.contestLayout.form.fields
					delete _this.contestLayout.form.thank_you_email
					delete _this.contestLayout.form.email_fields
				} else {
					for (let key in _this.contestLayout.form.fields) {
						_this.contestLayout.form[key] = _this.contestLayout.form.fields[key].request

						_this.contestLayout.form[`${key}_req`] = _this.contestLayout.form.fields[key].require
					}

					if (_this.contestLayout.form.no_age) {
						_this.contestLayout.form.min_age = 0
					}

					if (_this.campaignType === 'sw') {
						delete _this.contestLayout.form.thank_you_text
					}
				}

				if (_this.contestId) {
					UNOgames.updateContestLayout(_this.activeLocationId, _this.campaignId, _this.contestLayout.form, _this.contestLayout.design, _this.contestLayout.agreement, _this.contestId).then(response => {
						_this.clearForm()
						_this.process = 'next_actions'
						disabledButton.complete()
					}).catch(_this.$root.errorWrapper(e => {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
							case 'contest_already_exists':
								break

							default:
								// No default
							}
						}
						disabledButton.cancel()
					}))
				} else {
					UNOgames.createContestLayout(_this.activeLocationId, _this.campaignId, _this.contestLayout.form, _this.contestLayout.design, _this.contestLayout.agreement).then(response => {
						_this.clearForm()
						_this.process = 'next_actions'
						disabledButton.complete()
					}).catch(_this.$root.errorWrapper(e => {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
							case 'contest_already_exists':
								break

							default:
								// No default
							}
						}
						disabledButton.cancel()
					}))
				}
			}).catch(reason => {
				// If validation fails then display the error message
				_this.errorMessage = reason
				disabledButton.cancel()
			})
		},
		/**
		 * To check with the backend if there is a contest created for the current campaign and pull all details.
		 * @function
		 * @returns {undefined}
		 * @memberof EditContestLayout
		 * @version 0.0.9
		 */
		getContestDetails () {
			let _this = this

			UNOgames.getContestDetails(_this.activeLocationId, _this.campaignId).then(response => {
				_this.formatContestData(response.payload)
				_this.contestId = response.payload.contest.id
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {
					case 'contest_not_found':
						// Nothing to see here. If the contest is not found we will treat it as new.
						break

					default:
						// No default
					}
				}
			}))
		},
		/**
		 * To format the backend data to match the frontend json structure.
		 * @function
		 * @param {object} data - The backend data to be formatted.
		 * @returns {undefined}
		 * @memberof EditContestLayout
		 * @version 0.0.9
		 */
		formatContestData (data) {
			// Form Data
			this.contestLayout.form.skip_form = data.contest.skip_form
			this.contestLayout.form.language = data.contest.language
			this.contestLayout.form.form_instructions = data.contest.form_instructions
			this.contestLayout.form.thank_you_text = data.contest.thank_you_text
			this.contestLayout.form.fields.full_name.request = data.contest.full_name
			this.contestLayout.form.fields.full_name.require = data.contest.full_name_req
			this.contestLayout.form.fields.email.request = data.contest.email
			this.contestLayout.form.fields.email.require = data.contest.email_req
			this.contestLayout.form.fields.phone.request = data.contest.phone
			this.contestLayout.form.fields.phone.require = data.contest.phone_req
			this.contestLayout.form.fields.dob.request = data.contest.dob
			this.contestLayout.form.fields.dob.require = data.contest.dob_req
			this.contestLayout.form.email_fields.sender = data.contest.email_sender
			this.contestLayout.form.email_fields.subject = data.contest.email_subject
			this.contestLayout.form.email_fields.body = data.contest.email_body
			this.contestLayout.form.thank_you_email = data.contest.thank_you_email

			if (data.contest.min_age === 0) {
				this.contestLayout.form.no_age = true
			} else {
				this.contestLayout.form.min_age = data.contest.min_age
			}

			// Design Data
			this.contestLayout.design.text_color = data.contest.text_color
			this.contestLayout.design.background_color = data.contest.background_color
			this.contestLayout.design.background_image = data.contest.background_image
			this.contestLayout.design.button_background_color = data.contest.button_background_color
			this.contestLayout.design.button_background_hover_color = data.contest.button_background_hover_color
			this.contestLayout.design.button_text_color = data.contest.button_text_color
			this.contestLayout.design.font_family = data.contest.font_family
			this.contestLayout.design.font_weight = data.contest.font_weight
			this.contestLayout.design.footer_background_color = data.contest.footer_background_color
			this.contestLayout.design.footer_border_color = data.contest.footer_border_color
			this.contestLayout.design.footer_image = data.contest.footer_image
			this.contestLayout.design.header_image = data.contest.header_image
			this.contestLayout.design.input_background_color = data.contest.input_background_color
			this.contestLayout.design.input_placeholder_color = data.contest.input_placeholder_color
			this.contestLayout.design.input_text_color = data.contest.input_text_color

			// Agreement Data
			this.contestLayout.agreement.urls = [{url: data.contest.agreement_url_1, name: data.contest.agreement_name_1}, {url: data.contest.agreement_url_2, name: data.contest.agreement_name_2}]
		},
		/**
		 * To clear the object 'contestLayout'.
		 * @function
		 * @returns {undefined}
		 * @memberof EditContestLayout
		 * @version 0.0.9
		 */
		clearForm () {
			this.contestLayout = {
				form: {
					skip_form: false,
					language: 'english',
					form_instructions: '',
					thank_you_text: '',
					no_age: false,
					fields: {
						full_name: {
							request: true,
							require: false
						},
						email: {
							request: true,
							require: false
						},
						phone: {
							request: true,
							require: false
						},
						dob: {
							request: true,
							require: false
						}
					},
					thank_you_email: false,
					email_fields: {
						sender: '',
						subject: '',
						body: ''
					}
				},
				design: {
					text_color: '',
					input_text_color: '',
					background_color: '',
					background_image: '',
					header_image: '',
					footer_image: '',
					footer_background_color: '',
					footer_border_color: '',
					input_background_color: '',
					input_placeholder_color: '',
					button_text_color: '',
					button_background_color: '',
					button_background_hover_color: '',
					font_family: {},
					font_weight: 400
				},
				agreement: {
					urls: [
						{
							url: '',
							name: ''
						},
						{
							url: '',
							name: ''
						}
					],
					terms_error: '',
					require_access_code: false,
					access_code: ''
				}
			}
		},
		/**
		 * To run the function passed in.
		 * @function
		 * @param {string} functionName - The function that is to be run
		 * @param {array} params - The list of parameters being passed into the function
		 * @returns {undefined}
		 * @memberof EditContestLayout
		 * @version 0.0.9
		 */
		runFunction (functionName, params) {
			if (!params) {
				this[functionName]()
			} else {
				this[functionName](params[0])
			}
		}
	},
	components: {
		ContestPreview,
		Dropdown,
		FontPicker,
		InfoPopover,
		NextActions,
		StepCounter
	},
	watch: {
		/**
		 * To `watch` the $route in order to determine if this panel should be showing or not
		 * @function
		 * @returns {undefined}
		 * @memberof EditContestLayout
		 * @version 0.0.9
		 */
		'$route' () {
			if (this.$route.name === 'UNOgames - Edit Contest Layout') {
				this.activePanel = true
				this.clearError()
				this.clearForm()
				if (this.$route.params.campaign_id && this.$route.params.campaign_id !== 'undefined' && parseInt(this.$route.params.campaign_id) !== 0) {
					this.campaignId = this.$route.params.campaign_id

					this.transitionComplete = false
					setTimeout(() => {
						this.transitionComplete = true
					}, 600)

					this.getContestDetails()
				} else {
					this.closePanel()
				}
			} else {
				this.activePanel = false
			}
		},
		/**
		 * To `watch` the `campaignId` in order to determine when to make a call to pull in the campaign details.
		 * @function
		 * @returns {undefined}
		 * @memberof EditContestLayout
		 * @version 0.0.9
		 */
		'campaignId' () {
			if (this.campaignId !== 0) {
				let _this = this

				UNOgames.getCampaign(_this.activeLocationId, _this.campaignId).then(response => {
					_this.campaignType = response.payload.campaign.campaign_type
				}).catch(reason => {
					if (reason.responseJSON) {
						switch (reason.responseJSON.declaration) {}
					}
				})
			}
		}
	}
}
</script>
<style>
.margin-bottom-100 {
	margin-bottom: 100px !important;
}
.scroll-column {
	overflow: auto;
	height: calc(100vh - 129px);
}
textarea.form-control {
	resize: none;
}
.input-icon > i.wide {
	width: 65px;
}
</style>


// WEBPACK FOOTER //
// EditContestLayout.vue?34d7e29d